
class RfidSystem {
  framework;
  successCallback;
  errorCallback;
  qrCode;

  constructor(_framework) {
    this.framework = _framework;
  }

  setSuccessCallback(successCallback) {
    this.successCallback = successCallback;
  }

  setErrorCallback(errorCallback) {
    this.errorCallback = errorCallback;
  }

  processNfcTagReading(nfcTagReading) {
    try {
      if(this.successCallback !== null && this.successCallback !== undefined) {
        if (typeof this.successCallback === 'function') {
          this.successCallback(nfcTagReading);
        }        
      }
    }
    catch(error) {
      console.log(error);
    }
  }

  notifyError(rfidError) {
    try {
      if(this.errorCallback !== null && this.errorCallback !== undefined) {
        this.errorCallback(rfidError);
      }
    }
    catch(error) {
      console.log(error);
    }    

  }  
}


export default RfidSystem;